export type NotificationModel = {
    isError?: boolean;
    message: string;
};

/**
 * Trims out technical jargon from error messages
 * in: - Message: Oh no. Something went wrong.; Code 500
 * out: Oh no. Something went wrong.
 *
 * @export
 * @param {string} message
 * @returns {string}
 */
export function cleanErrorMessage(message: string): string {
    return message.replace("- Message: ", "").replace(/; Code: \d{3}/, "");
}
